import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const CheckIcon = RESIDENTS_SVG_COMPONENTS.CHECK;

type SelectionType = 'radio' | 'checkbox';

interface SelectableOptionProps {
  label: string;
  isSelected: boolean;
  onPress: () => void;
  type?: SelectionType;
}

/**
 * Shared selectable option component for radio buttons and checkboxes
 * Used in StepPriceCondition (radio) and StepPickupPreferences (checkbox)
 */
export const SelectableOption: React.FC<SelectableOptionProps> = ({
  label,
  isSelected,
  onPress,
  type = 'checkbox',
}) => {
  const isRadio = type === 'radio';

  return (
    <TouchableOpacity
      style={styles.optionItem}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <Text style={[
        styles.optionText,
        isSelected && styles.optionTextSelected,
      ]}>
        {label}
      </Text>
      <View style={styles.selectionContainer}>
        <View style={[
          styles.selectionOuter,
          isRadio ? styles.radio : styles.checkbox,
          isSelected && styles.selectionSelected,
        ]}>
          {isSelected && (
            isRadio ? (
              <View style={styles.radioInner} />
            ) : (
              <CheckIcon width={12} height={12} color={MARKETPLACE_COLORS.textPrimary} />
            )
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  optionItem: {
    backgroundColor: MARKETPLACE_COLORS.optionItemBackground,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  optionText: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  optionTextSelected: {
    fontWeight: '500',
  },
  selectionContainer: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectionOuter: {
    width: 16,
    height: 16,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.checkboxBorder,
    backgroundColor: MARKETPLACE_COLORS.checkboxBackground,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radio: {
    borderRadius: 8, // Full circle for radio
  },
  checkbox: {
    borderRadius: 4, // Rounded corners for checkbox
  },
  selectionSelected: {
    backgroundColor: MARKETPLACE_COLORS.checkboxSelected,
    borderColor: MARKETPLACE_COLORS.checkboxSelected,
  },
  radioInner: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: MARKETPLACE_COLORS.radioInner,
  },
});

